import { IMAGEPATH } from '../../constants/imagePath';
import { KR } from '../../constants/localizations';
import styles from '../../styles/products.module.css';

export default function ProductDeliveryRobotCardMini() {
    return (
        <div className={styles.container}>
            <div className={styles.robotDeliveryBS}>
                <div className={styles.imgBox}>
                    <img src={IMAGEPATH.mini} srcSet={IMAGEPATH.miniWebp} alt="ar247_robot" loading="lazy" />
                </div>
                <div className={styles.info}>
                    <h3>{KR.label_products_baeromi_mini}</h3>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_size}</span>
                        <span>455(w)x530(d)x741(h)mm</span>
                    </div>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_box}</span>
                        <span>160(w)x400(d)x330(h)x2EA</span>
                    </div>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_box_weight}</span>
                        <span>10Kg</span>
                    </div>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_speed}</span>
                        <span>0 km/h ~ 5km/h</span>
                    </div>
                    <div>
                        <span className={styles.label}>{KR.label_products_detail_sensor}</span>
                        <span>2D 카메라·3D 라이다·초음파</span>
                    </div>
                </div>
            </div>
            <div className={styles.robotBadge}>
                <span>물체 인식용 카메라 장착</span>
                <span>기체 식별 LED 장착</span>
                <span>비상정지 버튼</span>
                <span>물품 적재 보관소</span>
                <span>Door to Door 플랫폼</span>
                <span>엘리베이터 연동형 로봇</span>
            </div>
        </div>
    )
}
